import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { ContentCard } from '../../layout/ContentCard';
import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import ChainManagerForm from './ChainManagerForm';

const ChainManagerFormPage = () => {
  const { id } = useParams();
  const idNumber = Number(id);
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (isNaN(idNumber)) {
    navigate('/404', { replace: true });
    return null;
  }

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:chains.create.title')} />
      <ContentCard header={t(`pages:chains.chain_manager.invite`)} maxWidth={{ base: 'full', xl: '100%' }}>
        <ChainManagerForm id={idNumber} />
      </ContentCard>
    </ContentLayout>
  );
};

export default ChainManagerFormPage;
